module.exports = __webpack_public_path__ + "img/sangeeta.eb6bcc48.jpg";